import { FileTextOutlined } from "@ant-design/icons";
import { FC } from "react";
import { formatProjectRequirementSummary } from "../../projectRequirement";

interface ProjectRequirementCardSummaryProps {
  requirement?: string;
}

const ProjectRequirementCardSummary: FC<ProjectRequirementCardSummaryProps> = ({
  requirement,
}) => {
  const summary = formatProjectRequirementSummary(requirement);
  if (!summary) {
    return null;
  }
  return (
    <div className="projectCard__remark">
      <span className="projectCard__remarkLabel">
        <FileTextOutlined />
        项目需求
      </span>
      <p title={summary}>{summary}</p>
    </div>
  );
};

export default ProjectRequirementCardSummary;
